var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookCircle = function SvgFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    "aria-hidden": "true",
    className: "facebook-circle_svg__pbs-facebook-circle",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C9 0 0 9 0 20c0 9.9 7.2 18.1 16.7 19.8l.1-.1V25.6h-5V20h5v-4.4c0-5 3.2-7.8 7.8-7.8 1.4 0 3 .2 4.4.4v5.1h-2.6c-2.4 0-3 1.2-3 2.8V20h5.3l-.9 5.6h-4.4v14.1h-.2l.1.1C32.8 38.1 40 29.9 40 20 40 9 31 0 20 0"
  })));
};
export default SvgFacebookCircle;